import React from 'react';
import ProductPatternPage from './ProductPatternPage';
import './SweetCornPage.css';
import sweetcornLogo from '../images/sweetcorn-logo.png';
import sweetcornTyson from '../images/sweetcorn-tyson-img.png';
import sweetcornTapan from '../images/sweetcorn-tapan-img.jpeg';

const varieties = [
  {
    name: 'TYSON ',
    image: sweetcornTyson,
    description: [
      'TYSON is an F1 hybrid sweet corn variety developed for high productivity and adaptability across different growing seasons.',
      'Engineered to perform well under higher plant populations due to its unique plant structure and excellent standability.',
      'Sourced from Dynasty Agriseeds and suitable for both Kharif and Rabi seasons.',
      'Maturity: Reaches harvesting stage within 60 to 70 days after sowing.',
      'Yield potential: Estimated 20 to 40 quintals per acre under optimal conditions.',
      'Plant structure: Robust architecture with good standability for commercial cultivation.',
      'Seasonal adaptability: Well suited for multiple growing windows with reliable field performance.',
    ],
  },
  {
    name: 'TAPAN',
    image: sweetcornTapan,
    description: [
      'Popular F1 hybrid sweet corn variety with high productivity, uniform cobs, and strong Kharif and Rabi performance',
      'Maturity: Harvesting stage in about 60-70 days after sowing or 75-80 days after transplanting',
      'Yield potential: Estimated 20-40 quintals per acre',
      'Seed rate: Approximately 3-4 kg per acre',
      'Cob and kernel quality: Well-filled cobs with good tip filling and multiple kernel lines',
      'Seed treatment: Commonly treated with protective chemicals such as Captaf or Fortenza Duo',
      'Suitable for Kharif and Rabi cultivation with good standability',
    ],
  },
];

export default function SweetCornPage() {
  return <ProductPatternPage title="Sweet Corn" varieties={varieties} pageClass="sweetcorn-page" heroImage={sweetcornLogo} />;
}
